import CookiesUtility, { cookieNames } from '@/Utils/CookiesUtility.js';

let initialState = {
    analyticsConfig: null,
    checkoutCurrencies: [],
    currencySelectorVisible: false,
    currentCheckoutCurrencyId: null,
    displayCurrencies: [],
    featuredReward: null,
    preventCartLoading: false,
    projectContext: null,
    projectFollowerFacts: null,
    userAdditionalInfo: {
        followedProjectsIDs: [],
        followedUsersIDs: [],
        backedProjectsIDs: [],
        guestOrderToken: null,
    },
    projectState: {
        facts: null,
        projectAdditionalSettings: {
            pledgeManagerAvailability: null,
            enableShippingOnlyMode: false,
            allowNewOrders: false,
            hasAccessToLimitedPledgeManager: false,
        },
        stretchGoals: [],
        endgameState: {},
    },
    projectTracking: null,
    projectUserState: null,
    projectSystemCategories: null,
    promoItemState: null,
    userContext: null,
    availableLanguages: [],
    isInDarkMode: false,
};

const cookieCurrentDisplayCurrencyId = CookiesUtility.get(cookieNames.displayCurrency);

initialState.cookie = {
    currentDisplayCurrencyId: cookieCurrentDisplayCurrencyId ? parseInt(cookieCurrentDisplayCurrencyId) : null,
};

initialState = { ...initialState, ...window.__INITIAL_STATE__ };

export default initialState;